// import CopyButton from './CopyButton';
// import Number from './Number';
// import Price from './Price';
import classNames from 'classnames';
import dayjs from 'dayjs';
import { Link } from 'modules/i18n';

// import ContentEditable from './ContentEditable';

export type TableCellType =
  | 'Array'
  | 'Date'
  | 'DateTime'
  | 'Array'
  | 'ArrayBadges'
  | 'Link'
  | 'Price'
  // | 'Length'
  | 'Number'
  | 'Boolean'
  // | 'Image'
  // | 'CopyButton'
  // | 'EditInPlace'
  // | 'DateTime'
  | 'NoWrap';

export interface TableCellProps<T> {
  type?: TableCellType;
  value: any;
  default: any;
  href?: string | ((data: T) => string);
  data: T;
  cellProps?: any;
}

const Cell = <T,>({ value, type, default: defaultValue, href, data, cellProps }: TableCellProps<T>) => {
  if (!value && type !== 'Boolean') {
    return defaultValue;
  }

  if (type === 'DateTime') {
    return (
      <>
        <span className="block whitespace-nowrap">{dayjs(value).format('ll')}</span>
        <span className="block font-sans text-xs uppercase text-gray-400">{dayjs(value).format('HH:mm')}</span>
      </>
    );
  } else if (type === 'Date') {
    return <span>{dayjs(value).format('ll')}</span>;
  }

  if (type === 'Boolean') {
    return (
      <div
        className={classNames('badge badge-sm', {
          'badge-success': value,
          'badge-error': !value,
        })}
      ></div>
    );
  } else if (type === 'NoWrap') {
    return <span className="whitespace-nowrap">{value}</span>;
  } else if (type === 'Link') {
    let processedHref = href;
    if (typeof href === 'string') {
      processedHref = href.replace('[id]', (data as any).id);
    } else {
      processedHref = href?.(data);
    }
    return (
      <Link
        className="link link-neutral"
        href={processedHref}
        onClick={(e: any) => {
          e.stopPropagation();
        }}
      >
        {value}
      </Link>
    );
  } else if (type === 'Number') {
    return value;
  } else if (type === 'Price') {
    return value.toLocaleString('fr-FR', { style: 'currency', currency: cellProps?.currency || 'EUR' });
  } else if (type === 'Array') {
    return <span>{value.join(', ')}</span>;
  } else if (type === 'ArrayBadges') {
    return (
      <span className="flex items-center gap-1">
        {value.map((item: string) => (
          <span key={item} className="badge">
            {item}
          </span>
        ))}
      </span>
    );
  }

  return defaultValue;
};

export default Cell;

// const Cell = ({ value, column, row }: IProps) => {
//   const cellOptions = typeof column?.options === 'function' ? column?.options({ row }) : column?.options || {};

//   if (value === '-') {
//     return '-';
//   }

//   if (column?.type === 'Price') {
//     const { options, ...restOptions } = cellOptions || {};
//     const defaultCellOptions = {
//       minimumFractionDigits: 2,
//     };

//     return <Price value={value} options={{ ...defaultCellOptions, ...options }} {...restOptions} />;
//   }

//   if (column?.type === 'Number') {
//     return <Number value={value} {...cellOptions} />;
//   }

//   if (column?.type === 'Length') {
//     return <Number value={value.length} {...cellOptions} />;
//   }

//   if (column?.type === 'Image') {
//     const { placeholder, ...remainingOptions } = cellOptions;
//     return <img src={value || placeholder} alt="" {...remainingOptions} />;
//   }

//   if (column?.type === 'NoWrap') {
//     return <NoWrap {...cellOptions}>{value}</NoWrap>;
//   }

//   if (column?.type === 'CopyButton') {
//     return (
//       <CopyButton as="span" {...cellOptions}>
//         {value}
//       </CopyButton>
//     );
//   }
//   if (column?.type === 'EditInPlace') {
//     const { onSave, ...leftCellOptions } = cellOptions;
//     return <ContentEditable value={value} onSave={cellOptions.onSave(row?.original)} {...leftCellOptions} />;
//   }

//   if (column?.type) {
//     const ReactElement = column?.type;
//     // @ts-ignore
//     return <ReactElement value={value} {...cellOptions} />;
//   }

//   return value;
// };

// export default Cell;
